// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"bef965f2","361":"a21a56a6","511":"fefdf482","767":"87f68d69"}[chunkId] + ".chunk.js";
};